import classNames from 'classnames'
import { useContext } from 'react'
import { NavigationLinksContext } from '#features/navigation'
import { Navbar } from '#features/navigation'
import styles from './navigatable-layout.module.scss'

interface NavigatableLayoutProps {
  className?: string
  children?: React.ReactNode
}

export default function NavigatableLayout({ className, children }: NavigatableLayoutProps) {
  const navigationLinks = useContext(NavigationLinksContext)

  const isNavbarShown = navigationLinks.length > 0

  return (
    <div className={classNames(className, styles.root)}>
      <div className={classNames(styles.content, isNavbarShown && styles.contentWithNavbar)}>{children}</div>

      {navigationLinks.length > 0 && (
        <div className={styles.navbarWrap}>
          <Navbar className={styles.navbar} links={navigationLinks} />
        </div>
      )}
    </div>
  )
}
